import { render, staticRenderFns } from "./UploaderItem.vue?vue&type=template&id=47451658&"
import script from "./UploaderItem.vue?vue&type=script&lang=js&"
export * from "./UploaderItem.vue?vue&type=script&lang=js&"
import style0 from "./UploaderItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports